// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  visits7D: __t.u32().name("visits_7_d"),
  uniqueVisitors7D: __t.u32().name("unique_visitors_7_d"),
  avgRating: __t.f32().name("avg_rating"),
  ratingCount: __t.u32().name("rating_count"),
  visualPollution: __t.f32().name("visual_pollution"),
  hotScore: __t.f32().name("hot_score"),
  lastVisitAt: __t.timestamp().name("last_visit_at"),
  hidden: __t.bool(),
  delisted: __t.bool(),
  updatedAt: __t.timestamp().name("updated_at"),
});
